import React from 'react'
import './styles.css'

const Screen = (props) => {
    return (
        <div className='screen'>{props.show}</div>
    )
}

export default Screen